const Bot = () => import('./Index.vue');
const BotTypeSelector = () => import('./BotTypeSelector.vue');
const CsmlEditBot = () => import('./csml/Edit.vue');
const CsmlNewBot = () => import('./csml/New.vue');
const N8nEditBot = () => import('./n8n/Edit.vue');
const N8nNewBot = () => import('./n8n/New.vue');
const TypebotEditBot = () => import('./typebot/Edit.vue');
const TypebotNewBot = () => import('./typebot/New.vue');
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: params => {
        const showBackButton = params.name !== 'agent_bots';
        return {
          headerTitle: 'AGENT_BOTS.HEADER',
          icon: 'bot',
          newButtonRoutes: ['agent_bots'],
          showBackButton,
        };
      },
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'AGENT_BOTS.HEADER',
          icon: 'bot',
          showBackButton: true,
        };
      },
      children: [
        {
          path: 'new',
          name: 'agent_bots_new',
          component: BotTypeSelector,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'csml/new',
          name: 'agent_bots_csml_new',
          component: CsmlNewBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'csml/:botId',
          name: 'agent_bots_csml_edit',
          component: CsmlEditBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'n8n/new',
          name: 'agent_bots_n8n_new',
          component: N8nNewBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'n8n/:botId',
          name: 'agent_bots_n8n_edit',
          component: N8nEditBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'typebot/new',
          name: 'agent_bots_typebot_new',
          component: TypebotNewBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'typebot/:botId',
          name: 'agent_bots_typebot_edit',
          component: TypebotEditBot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
